export default {"src":"/_next/static/media/face-mask.096bb3f5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};